import React from "react";
import NavMenu from "./navMenu";

const FullWidthPage = ({ loggedIn, accountPermission, children }) => (
  <div>
    {loggedIn() && <div className="nav-background" />}
    <div className="container">
      {loggedIn() && <NavMenu accountPermission={accountPermission} />}
    </div>

    {children}
  </div>
);

export default FullWidthPage;
